import { render, staticRenderFns } from "./goals.vue?vue&type=template&id=770071ff&scoped=true"
import script from "./goals.vue?vue&type=script&lang=js"
export * from "./goals.vue?vue&type=script&lang=js"
import style0 from "./goals.vue?vue&type=style&index=0&id=770071ff&prod&scoped=true&lang=less"
import style1 from "./goals.vue?vue&type=style&index=1&id=770071ff&prod&lang=css"
import style2 from "./goals.vue?vue&type=style&index=2&id=770071ff&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770071ff",
  null
  
)

export default component.exports